import React from 'react';
import Cards from '../../Cards';
import { useLocation } from 'react-router-dom';


const ConsumablesReq = () => {

const formattedPath = useLocation().pathname.split("/").filter(x => x !== "");
const pathprop = formattedPath[formattedPath.length - 1]

return (
    <Cards pathValue={pathprop} />
  )
}

export default ConsumablesReq